import { useEffect, useState } from "react";
import useCerosScript from "@hooks/useCerosScript";
import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

/**
 * Renders a dynamic iframe element in an article.
 * This component processes the body string to extract and add the necessary scripts to the page.
 */
const DynamicIframe = ({ bodyString, className }: ArticleNonParagraphProps) => {
  const [sanitizedBodyString, setSanitizedBodyString] = useState<string>("");

  useCerosScript();

  useEffect(() => {
    const sanitizedBodyString = DOMPurify.sanitize(bodyString, {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: [
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "src",
        "width",
        "height",
        "style",
        "id",
        "class",
        "className",
        "title",
        "referrerpolicy",
      ],
    });
    setSanitizedBodyString(sanitizedBodyString);
  }, [bodyString]);

  return (
    <div
      data-testid="article-dynamic-iframe-component"
      className={cn("mb-6", className)}
    >
      {parse(sanitizedBodyString)}
    </div>
  );
};

export default DynamicIframe;
